import { render } from "./MoveToCompleted.vue?vue&type=template&id=4fabfee6"
import script from "./MoveToCompleted.vue?vue&type=script&lang=js"
export * from "./MoveToCompleted.vue?vue&type=script&lang=js"

import exportComponent from "D:\\MAMP\\htdocs\\electra\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__